export default function (Component) {
      Component.options.__i18n = {"cancel_text":{"en":"cancel","zh-CN":"取消"},"confirm_text":{"en":"ok","zh-CN":"完成"}}
    }